import * as React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import {Trans} from "@lingui/react/macro";

export default function Copyright(props: any) {
    return (
        <Typography variant="body2" align="center" {...props} sx={{ color: "text.secondary" }}>
            TimberStorage | <Link color="inherit" href="https://iokrono.com">IOKrono d.o.o.</Link> © {new Date().getFullYear()} | <Trans>Version</Trans>: 0.9.7 | 2026-10-25 11:00
        </Typography>
    );
}
